<template>
  <div>
    <app-header :title="$store.getters['translations/getLabel']('STORES')" />
    <b-container>
      <StoreList />
    </b-container>
  </div>
</template>

<script>
import $auth from '@/services/auth';
import StoreList from '@/components/StoreList';
import AppHeader from '@/components/AppHeader';

export default {
  components: {
    StoreList,
    AppHeader,
  },
  data() {
    return {
      auth: $auth,
    };
  },
  // created() {
  //   this.$store.dispatch('global/getStores');
  // },
};
</script>
